import { Controller } from '@hotwired/stimulus'

// Moovit WTP widget bootstrap. Turbo Drive re-executes body scripts while the
// new body is still detached, so an inline loader can inject the widget script
// into a document that is discarded a moment later — the iframe never renders
// until a full page reload. The widget script itself is idempotent (it
// replaces each .mv-wtp element's innerHTML on every run), so we load it from
// here instead: connect() fires after every Turbo render, on the live body.
export default class extends Controller {
  connect () {
    const scriptId = 'moovit-jsw'
    const existing = document.getElementById(scriptId)
    if (existing) return

    if (!document.body.contains(existing)) window.__ladotMoovitScriptPromise = null
    if (window.__ladotMoovitScriptPromise) return

    const script = document.createElement('script')
    script.id = scriptId
    script.src = 'https://widgets.moovit.com/wtp/en'
    script.async = true
    window.__ladotMoovitScriptPromise = new Promise((resolve, reject) => {
      script.addEventListener('load', resolve, { once: true })
      script.addEventListener('error', reject, { once: true })
    })
    this.element.appendChild(script)
  }
}
